<script lang="ts" setup></script>

<template>
  <svg
    fill="none"
    height="100%"
    viewBox="0 0 20 20"
    width="100%"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="icon / icon" clip-path="url(#clip0_9001_28317)">
      <path
        id="Vector"
        d="M5.04548 19.9991C4.54548 19.9991 4.1176 19.8212 3.76184 19.4655C3.40608 19.1097 3.2279 18.6815 3.22729 18.1809V9.09002C3.22729 8.59002 3.40548 8.16214 3.76184 7.80639C4.1182 7.45063 4.54608 7.27245 5.04548 7.27184H5.95457V5.45366C5.95457 4.19608 6.3979 3.12426 7.28457 2.2382C8.17123 1.35214 9.24305 0.908809 10.5 0.908203C11.7576 0.908203 12.8297 1.35154 13.7164 2.2382C14.6031 3.12487 15.0461 4.19669 15.0455 5.45366V7.27184H15.9546C16.4546 7.27184 16.8827 7.45002 17.2391 7.80639C17.5955 8.16275 17.7734 8.59063 17.7727 9.09002V18.1809C17.7727 18.6809 17.5949 19.1091 17.2391 19.4655C16.8834 19.8218 16.4552 19.9997 15.9546 19.9991H5.04548ZM5.04548 18.1809H15.9546V9.09002H5.04548V18.1809ZM10.5 15.4537C11 15.4537 11.4282 15.2758 11.7846 14.92C12.1409 14.5643 12.3188 14.1361 12.3182 13.6355C12.3182 13.1355 12.1403 12.7076 11.7846 12.3518C11.4288 11.9961 11.0006 11.8179 10.5 11.8173C10 11.8173 9.57214 11.9955 9.21639 12.3518C8.86063 12.7082 8.68245 13.1361 8.68184 13.6355C8.68184 14.1355 8.86002 14.5637 9.21639 14.92C9.57275 15.2764 10.0006 15.4543 10.5 15.4537ZM7.77275 7.27184H13.2273V5.45366C13.2273 4.69608 12.9621 4.05214 12.4318 3.52184C11.9015 2.99154 11.2576 2.72638 10.5 2.72638C9.74245 2.72638 9.09851 2.99154 8.5682 3.52184C8.0379 4.05214 7.77275 4.69608 7.77275 5.45366V7.27184Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_9001_28317">
        <rect fill="white" height="20" transform="translate(0.5)" width="20" />
      </clipPath>
    </defs>
  </svg>
</template>

<style scoped lang="sass"></style>
